
const BackToTop = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // smooth scrolling
    });
  };

  return (
    <div className="fixed bottom-5 md:bottom-10 lg:bottom-20 right-5 md:right-10 lg:right-16 z-50">
      <div className="btn w-14 h-14 md:w-20 md:h-20 bg-black/50 backdrop-blur-2xl rounded-full p-5 flex justify-center items-center text-[#380B4C] cursor-pointer"
           onClick={scrollToTop}>
        <svg
          className="w-7 h-7 md:w-8 md:h-8"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5 10l7-7m0 0l7 7m-7-7v18"
          ></path>
        </svg>
      </div>
    </div>
  );
};

export default BackToTop;
